import React, {Component} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import LoaderButton from '../../../components/LoaderButton';
import Breadcrumb from '../../../containers/navs/Breadcrumb';
import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
import {NotificationManager} from "../../../components/common/react-notifications";
import ModalManager from "../../../components/modal/ModalManager";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import {getField} from "../../../helpers/core";
import {keyBy, map, find, reduce, indexOf} from "lodash";
import fa_IR from "../../../constants/locales";
import i18n from "../../../services/i18n";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import Api from "../../../services/Api";
import moment from "moment";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      boardTypes: null,
    };
  }

  componentDidMount() {
    this.fetchBoardTypes();
  }

  fetchBoardTypes = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/boards/types');
      this.setState({
        boardTypes: keyBy(data.rows, 'name'),
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  createCampaign = async values => {
    const {t} = this.props;
    const {boardTypes} = this.state;
    const {
      name,
      type,
      activityRangeType,
      startDate,
      finishDate,
      duration,
      updateType,
      updatePeriod,
      maximumRank,
      visibility,
      entered,
      exit,
      enterUpperLimit,
      exitUpperLimit,
      enterLowerLimit,
      exitLowerLimit,
      upperDisplacement,
      lowerDisplacement,
      scoreFunctions,
      inclusionFunctions,
    } = values;
    try {
      await Api.invoke('POST', '/v2/admin-ui/boards', {
        name,
        type: type.value,
        activityRange: {
          type: activityRangeType.value,
          start: startDate ? moment(startDate).toISOString() : null,
          end: finishDate ? moment(finishDate).toISOString() : null,
          duration: duration ? Number(duration) : null,
        },
        inclusionFunctions: inclusionFunctions.map(item => ({
          name: item.value,
          params: reduce(
            find(boardTypes[values.type.value].inclusionFunctions, {name: item.value}).params,
            (result, value) => {
              return {
                ...result,
                ...(values[`${item.value}${value.name}`] ? {[value.name]: values[`${item.value}${value.name}`]} : null)
              }
            },
            {}
          ),
        })),
        scoreFunctions: scoreFunctions.map(item => ({
          name: item.value,
          params: reduce(
            find(boardTypes[values.type.value].scoreFunctions, {name: item.value}).params,
            (result, value) => {
              return {
                ...result,
                ...(values[`${item.value}${value.name}`] ? {[value.name]: values[`${item.value}${value.name}`]} : null)
              }
            },
            {}
          ),
        })),
        updatePeriod: {
          type: updateType.value,
          ...(updateType.value === "OFFLINE" ? {period: updatePeriod.value} : null)
        },
        maximumRank: Number(maximumRank),
        notifications: {
          entered,
          exit,
          enterUpperLimit: Number(enterUpperLimit),
          exitUpperLimit: Number(exitUpperLimit),
          enterLowerLimit: Number(enterLowerLimit),
          exitLowerLimit: Number(exitLowerLimit),
          upperDisplacement: Number(upperDisplacement),
          lowerDisplacement: Number(lowerDisplacement),
        },
        visibility,
      });
      NotificationManager.success(t('Campaign {{name}} started successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  openConfirmDialog = onConfirm => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Submit Confirm'),
      body: t('Are you sure you want to start campaign ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            onConfirm();
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  getUpdateTypeOptions = type => {
    const {boardTypes} = this.state;
    const {acceptableUpdatePeriod} = boardTypes[type];
    return reduce(acceptableUpdatePeriod, (res, item) => {
      return indexOf(res, item.type) >= 0 ? res : [...res, item.type];
    }, []);
  };

  getUpdatePeriodOptions = type => {
    const {boardTypes} = this.state;
    const {acceptableUpdatePeriod} = boardTypes[type];
    return map(acceptableUpdatePeriod, 'period');
  };

  getActivityRangeOptions = type => {
    const {boardTypes} = this.state;
    const {acceptableActivityRange} = boardTypes[type];
    return reduce(acceptableActivityRange, (res, item) => {
      return indexOf(res, item.type) >= 0 ? res : [...res, item.type];
    }, []);
  };

  render() {
    const {t, match} = this.props;
    const {boardTypes} = this.state;
    return (
      <MuiPickersUtilsProvider
        utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
        locale={i18n.language}>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Create New Campaign')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createCampaign}
                  render={({form, handleSubmit, submitting, pristine, hasValidationErrors, values}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row className="pt-3">
                          <Col className="col-lg-5 col-md-12">
                            <div className="text-one font-weight-semibold mb-4">
                              {t("Main info")}:
                            </div>
                            <Row className="mb-2">
                              <Col>
                                {getField("text", {
                                  name: 'name',
                                  label: t('Name'),
                                  required: true,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col>
                                {getField("select", {
                                  name: 'type',
                                  label:t('Board Type'),
                                  options: boardTypes ? map(boardTypes, item => ({label: item.name, value: item.name})) : [],
                                  onChange: selected => {
                                    form.restart({
                                      type: selected,
                                      name: values.name,
                                    });
                                  },
                                  required: true,
                                })}
                              </Col>
                            </Row>
                            {!!boardTypes && !!values.type && !!boardTypes[values.type.value] &&
                              <Row className="mb-3">
                                <Col>
                                  {getField("select", {
                                    name: 'activityRangeType',
                                    label: t('Activity Range Type'),
                                    options: map(this.getActivityRangeOptions(values.type.value), item => ({
                                      label: item,
                                      value: item
                                    })),
                                    required: true,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.activityRangeType && values.activityRangeType.value === "STATIC" &&
                              <Row className="mb-4">
                                <Col>
                                  {getField("datetime", {
                                    name: "startDate",
                                    label: t('Start Date'),
                                    required: true,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.activityRangeType && values.activityRangeType.value === "STATIC" &&
                              <Row className="mb-4">
                                <Col>
                                  {getField("datetime", {
                                    name: "finishDate",
                                    label: t('End Date'),
                                    minDate: moment(),
                                    required: false,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.activityRangeType && values.activityRangeType.value === "DYNAMIC" &&
                              <Row className="mb-2">
                                <Col>
                                  {getField("int", {
                                    name: 'duration',
                                    label: t('Board activity duration days'),
                                    required: false,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!boardTypes && !!values.type && !!boardTypes[values.type.value] &&
                              <Row className="mb-3">
                                <Col>
                                  {getField("select", {
                                    name: 'inclusionFunctions',
                                    label: t('Inclusion Functions'),
                                    options: boardTypes[values.type.value]["inclusionFunctions"].map(item => ({
                                      label: item.name, value: item.name,
                                    })),
                                    required: false,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.type && !!boardTypes[values.type.value] && !!values.inclusionFunctions && values.inclusionFunctions.length > 0 &&
                              values.inclusionFunctions.map(item => {
                                return find(boardTypes[values.type.value]["inclusionFunctions"], {name: item.value}).params.map(param => {
                                  return (
                                    <Row className="mb-2" key={item.value + param.name}>
                                      <Col>
                                        {getField(param.type, {
                                          name: `${item.value}${param.name}`,
                                          label: `${item.value} ${param.name}`,
                                          required: true,
                                        })}
                                      </Col>
                                    </Row>
                                  );
                                });
                              })
                            }
                            {!!boardTypes && !!values.type && !!boardTypes[values.type.value] &&
                              <Row className="mb-3">
                                <Col>
                                  {getField("select", {
                                    name: 'scoreFunctions',
                                    label: t('Score Functions'),
                                    options: boardTypes[values.type.value]["scoreFunctions"].map(item => ({
                                      label: item.name, value: item.name,
                                    })),
                                    required: true,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.type && !!boardTypes[values.type.value] && !!values.scoreFunctions && values.scoreFunctions.length > 0 &&
                              values.scoreFunctions.map(item => {
                                return find(boardTypes[values.type.value]["scoreFunctions"], {name: item.value}).params.map(param => {
                                  return (
                                    <Row className="mb-2" key={item.value + param.name}>
                                      <Col>
                                        {getField(param.type, {
                                          name: `${item.value}${param.name}`,
                                          label: `${item.value} ${param.name}`,
                                          required: true,
                                        })}
                                      </Col>
                                    </Row>
                                  );
                                });
                              })
                            }
                            {!!boardTypes && !!values.type && !!boardTypes[values.type.value] &&
                              <Row className="mb-3">
                                <Col>
                                  {getField("select", {
                                    name: 'updateType',
                                    label: t('Board Update Type'),
                                    options: map(this.getUpdateTypeOptions(values.type.value), item => ({
                                      label: item,
                                      value: item
                                    })),
                                    required: true,
                                  })}
                                </Col>
                              </Row>
                            }
                            {!!values.updateType && values.updateType.value === "OFFLINE" &&
                              <Row className="mb-3">
                                <Col>
                                  {getField("select", {
                                    name: 'updatePeriod',
                                    label:t('Board Update Period'),
                                    options: map(this.getUpdatePeriodOptions(values.type.value), item => ({
                                      label: item,
                                      value: item
                                    })),
                                    required: true,
                                  })}
                                </Col>
                              </Row>
                            }
                            <Row className="mb-2">
                              <Col>
                                {getField("int", {
                                  name: 'maximumRank',
                                  label: t('Board Max Ranking'),
                                  required: true,
                                })}
                              </Col>
                            </Row>
                            <div className="d-flex flex-row my-3 align-items-center ml-0">
                              <div>
                                {t('Visible board for users')}
                              </div>
                              <div className="ml-4">
                                {getField("boolean", {
                                  name: "visibility",
                                })}
                              </div>
                            </div>
                          </Col>
                          <Col className="col-lg-5 col-12 ml-lg-5 ml-0">
                            <div className="text-one font-weight-semibold mb-4 mt-lg-0 mt-4">
                              {t("Notification settings")}:
                            </div>
                            <div className="d-flex flex-row mb-3 align-items-center ml-0">
                              <div>
                                {t('Send notifications to board entered users')}
                              </div>
                              <div className="ml-4">
                                {getField("boolean", {
                                  name: "entered",
                                })}
                              </div>
                            </div>
                            <div className="d-flex flex-row mb-4 align-items-center ml-0">
                              <div>
                                {t('Send notifications to board exited users')}
                              </div>
                              <div className="ml-4">
                                {getField("boolean", {
                                  name: "exit",
                                })}
                              </div>
                            </div>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'enterUpperLimit',
                                  label: t('Board enterUpperLimit notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'exitUpperLimit',
                                  label: t('Board exitUpperLimit notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'enterLowerLimit',
                                  label: t('Board enterLowerLimit notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'exitLowerLimit',
                                  label: t('Board exitLowerLimit notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'upperDisplacement',
                                  label: t('Board upperDisplacement notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col className="col-12 col-xl-10">
                                {getField("int", {
                                  name: 'lowerDisplacement',
                                  label: t('Board lowerDisplacement notifications'),
                                  required: false,
                                })}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <LoaderButton
                          size="xl"
                          loading={submitting}
                          onClick={() => {
                            this.openConfirmDialog(
                              handleSubmit,
                            );
                          }}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-5 text-center text-medium"
                          style={{minWidth: '100px'}}>
                          {t('Submit')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withTranslation()(Create);
